import { createContext, useContext } from "react";
import { noop } from "../../../helpers/general";
import { FinancialDocumentDetailsView } from "./usePathBasedFinancialDocumentDetailsView";

export interface FinancialDocumentDetailsContext {
    currentView: FinancialDocumentDetailsView;
    changeView(view: FinancialDocumentDetailsView): void;
}

export const financialDocumentDetailsContext =
    createContext<FinancialDocumentDetailsContext>({
        currentView: FinancialDocumentDetailsView.DEFAULT,
        changeView: noop,
    });

export function useFinancialDocumentDetailsContext() {
    const ctx = useContext(financialDocumentDetailsContext);

    if (!ctx) {
        throw new Error(
            "useFinancialDocumentDetailsContext must be used within a FinancialDocumentDetailsProvider",
        );
    }

    return ctx;
}
